/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 73) {
        $("body").addClass("fixed-header");
    } else {
        $("body").removeClass("fixed-header");
    }
});